/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Definition } from "./definition";
import { Gloss } from "./gloss";
import { GrammaticalInfo } from "./grammatical-info";
import { ProtectReason } from "./protect-reason";
import { SemanticDomain } from "./semantic-domain";
import { Status } from "./status";

/**
 *
 * @export
 * @interface Sense
 */
export interface Sense {
  /**
   *
   * @type {string}
   * @memberof Sense
   */
  guid: string;
  /**
   *
   * @type {Status}
   * @memberof Sense
   */
  accessibility: Status;
  /**
   *
   * @type {GrammaticalInfo}
   * @memberof Sense
   */
  grammaticalInfo: GrammaticalInfo;
  /**
   *
   * @type {Array<Definition>}
   * @memberof Sense
   */
  definitions: Array<Definition>;
  /**
   *
   * @type {Array<Gloss>}
   * @memberof Sense
   */
  glosses: Array<Gloss>;
  /**
   *
   * @type {Array<ProtectReason>}
   * @memberof Sense
   */
  protectReasons?: Array<ProtectReason> | null;
  /**
   *
   * @type {Array<SemanticDomain>}
   * @memberof Sense
   */
  semanticDomains: Array<SemanticDomain>;
}
